<template>
	<div class="zjss">
		<!-- zjss -->
		<ul class="title1">
			<li class="L"><router-link to="/shushuo">中经数说</router-link></li>
			<li class="M"></li>
			<li class="R"><router-link to="/shushuo" class="more3">更多</router-link></li>
		</ul>
		<el-skeleton :rows="8" :loading="isloading" animated >
			<div  class="zjss_scroll_wrap"><!-- zjss_scroll_wrap -->
				<div class="zjss_scroll"><!-- zjss_scroll -->
					<div class="zjss_scroll_list ">
						<div  id="left" @click="showpage=0" class="arrow" :style="{'pointer-events':showpage==0?'none':''}"></div>
						<ul>
							<li v-if="(showpage==0&&index<3)||(showpage==1&&index>2)" v-for="(item,index) in shushuoList.data" :key="item.id">
								<a @click="jumppush('/detail/'+item.id+'/1?favtype=3&col=shushuo')">
									<h4 style="padding: 11px 16px;">
										<p style="width: 280px; height: 26px;font-size: 16px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="item.title">
											<!-- <div style="width: 280px; height: 64px;font-size: 20px;white-space: normal; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 2;"> -->
												<!-- <span style="display: table-cell;vertical-align: middle;"> -->
													<!-- {{item.title&&item.title.length>28?item.title.substring(0,27)+'...':item.title}} -->
													{{item.title}}
												<!-- </span> -->
											<!-- </div> -->
										</p>
									</h4>
									<img :src="shushuoList.images[item.id]?shushuoList.images[item.id]:'images/hot_img.jpg'" alt="" style="width: 378px;height: 284px;"/>
								</a>
							</li>
						</ul>
						<div  id="right" @click="showpage=1" class="arrow" :style="{'pointer-events':(showpage==1||(shushuoList.data&&shushuoList.data.length<4))?'none':''}"></div>
					</div>
				</div><!-- /zjss_scroll -->						
				
			</div><!-- /zjss_scroll_wrap -->
		</el-skeleton>
	</div><!-- /zjss -->
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				shushuoList: [],
				showindex:0,
				showshushuoList:[],
				showpage:0,
			}
		},
		created: function() {
			this.shushuofnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					this.$cookies.set('fromdetail',to);
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			shushuofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'searchArticles',
						responseType: 'json',
						params: {
							columnID: '29c664145734422bbb342b5d1651cf2a',
							isTopArticle: '1',
							iPage:'1',
							pageSize:'6',
						},
					})
					.then(function(response) {
						_this.shushuoList = response.data.data.data;
						// _this.changeshow();
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
						_this.isloading=false;
					});
			},
			// shownext:function(){
			// 	this.showindex=(this.showindex+1)%(this.shushuoList.data.length);
			// 	this.showshushuoList.shift();
			// 	this.showshushuoList.push(this.shushuoList.data[(this.showindex+2)%(this.shushuoList.data.length)]);
			// 	// this.changeshow();
			// },
			// showpre:function(){
			// 	this.showindex=(this.showindex-1)<0?(this.shushuoList.data.length-1):(this.showindex-1);
			// 	this.showshushuoList.pop();
			// 	this.showshushuoList.unshift(this.shushuoList.data[this.showindex]);
			// 	// this.changeshow();
			// },
			// changeshow:function(pagenum){
			// 	this.showshushuoList=[];
			// 	this.showshushuoList[0]=this.shushuoList.data[this.showindex];
			// 	this.showshushuoList[1]=this.shushuoList.data[(this.showindex+1)%(this.shushuoList.data.length)];
			// 	this.showshushuoList[2]=this.shushuoList.data[(this.showindex+2)%(this.shushuoList.data.length)];
			// },
		}
	}
</script>

<style>
	
</style>
